var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryMultimedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 13.962C3.83301 13.3781 3.83301 13.0862 3.85737 12.8403C4.09234 10.4687 5.96845 8.59259 8.34003 8.35761C8.58592 8.33325 8.8936 8.33325 9.50898 8.33325C9.7461 8.33325 9.86466 8.33325 9.96532 8.32716C11.2507 8.24931 12.3763 7.43805 12.8566 6.24325C12.8942 6.14968 12.9294 6.04421 12.9997 5.83325C13.07 5.6223 13.1052 5.51682 13.1428 5.42325C13.6231 4.22846 14.7487 3.41719 16.034 3.33935C16.1347 3.33325 16.2459 3.33325 16.4682 3.33325H24.5311C24.7535 3.33325 24.8647 3.33325 24.9653 3.33935C26.2507 3.41719 27.3763 4.22846 27.8566 5.42325C27.8942 5.51682 27.9294 5.6223 27.9997 5.83325C28.07 6.04421 28.1052 6.14968 28.1428 6.24325C28.6231 7.43805 29.7487 8.24931 31.034 8.32716C31.1347 8.33325 31.2533 8.33325 31.4904 8.33325C32.1057 8.33325 32.4134 8.33325 32.6593 8.35761C35.0309 8.59259 36.907 10.4687 37.142 12.8403C37.1663 13.0862 37.1663 13.3781 37.1663 13.962V26.9999C37.1663 29.8002 37.1663 31.2003 36.6214 32.2699C36.142 33.2107 35.3771 33.9756 34.4363 34.455C33.3667 34.9999 31.9666 34.9999 29.1663 34.9999H11.833C9.03275 34.9999 7.63261 34.9999 6.56306 34.455C5.62225 33.9756 4.85734 33.2107 4.37798 32.2699C3.83301 31.2003 3.83301 29.8002 3.83301 26.9999V13.962Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4997 27.4999C24.1816 27.4999 27.1663 24.5151 27.1663 20.8333C27.1663 17.1514 24.1816 14.1666 20.4997 14.1666C16.8178 14.1666 13.833 17.1514 13.833 20.8333C13.833 24.5151 16.8178 27.4999 20.4997 27.4999Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMultimedia);
export default __webpack_public_path__ + "react/media/category-multimedia.e619dfb22748c27a05615bb6641c7c21.svg";
export { ForwardRef as ReactComponent };